export const toolbarTitleReducer = (state = {title: ""}, action) => {
    switch(action.type){
        case 'SET_TOOLBAR_TITLE': return {...state, title: action.payload.title
        }
        default: return state
    }
}
